import { render, staticRenderFns } from "./SplineChart.vue?vue&type=template&id=31d3a5e6"
import script from "./SplineChart.vue?vue&type=script&lang=js"
export * from "./SplineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports